export { messages as defaultMessages } from './en/catalog'

export const localesCodes = [
  'en',
  'en-gb',
  'es',
  'es-419',
  'es-us',
  'fr',
  'id',
  'hi',
  'it',
  'ko',
  'pt-br',
  'uk',
  'tr',
  'vi',
  'zh',
  'zh-tw',
]

export const sourceLocale = 'en'

export const localeFiles = {
  en: () => import('./en/catalog.js'),
  'en-gb': () => import('./en-gb/catalog.js'),
  es: () => import('./es/catalog.js'),
  'es-419': () => import('./es-419/catalog.js'),
  'es-us': () => import('./es-us/catalog.js'),
  fr: () => import('./fr/catalog.js'),
  id: () => import('./id/catalog.js'),
  hi: () => import('./hi/catalog.js'),
  it: () => import('./it/catalog.js'),
  ko: () => import('./ko/catalog.js'),
  'pt-br': () => import('./pt-br/catalog.js'),
  uk: () => import('./uk/catalog.js'),
  tr: () => import('./tr/catalog.js'),
  vi: () => import('./vi/catalog.js'),
  zh: () => import('./zh/catalog.js'),
  'zh-tw': () => import('./zh-tw/catalog.js'),
}
